import React, { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { RESET_PASSWORD } from './constants'
import './scss/resetPass.scss'

import 'react-toastify/dist/ReactToastify.css'

const ResetPasswordPage = () => {
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')

  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')

  const handlePasswordChange = (e) => {
    setPassword(e.target.value)
  }

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setError('')

    // Perform validation for password and confirm password
    if (password !== confirmPassword) {
      setError('Passwords do not match')
    } else if (!password || !confirmPassword) {
      setError('Please enter both password and confirm password')
    } else {
      fetch(RESET_PASSWORD, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ password })
      })
        .then((response) => {
          if (response.ok) {
            window.alert('SAVED PASSWORD')
            localStorage.setItem('token', token)
            navigate('/')
          } else {
            throw new Error('An error occurred during password reset')
          }
        })
        .catch((error) => {
          // Show alert error when there is an error
          window.alert(error.message)
          setError('Please enter both password and confirm password')
        })
    }
  }

  return (
    <div
      className="d-flex align-items-center justify-content-center vh-100 main-login"
      style={{ fontFamily: 'Poppins, sans-serif' }}
    >
      <div
        className="col-md-6 d-none d-md-block position-absolute top-0 start-0 h-100"
        style={{
          backgroundColor: '#2C6FEB'
        }}
      >
        <div className="position-absolute top-0 start-0 m-4 text-white fw-bold top-left-logo">
          LOG
          <span
            style={{
              backgroundColor: 'white',
              color: '#2C6FEB',
              padding: '5px',
              borderRadius: '4px'
            }}
            className="top-left-logo ms-1"
          >
            BOOK
          </span>
        </div>
      </div>
      <div className="reset_password bg-white border border-light">
        <h1>Reset Password</h1>
        <div className="reset_password_form w-100">
          <form onSubmit={handleSubmit}>
            <label>New Password:</label>
            <input
              type="password"
              className="custom-input-modal bg-white"
              value={password}
              onChange={handlePasswordChange}
            />
            <label>Confirm Password:</label>
            <input
              type="password"
              className="custom-input-modal bg-white"
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
            />
            <button className="custom-btn" type="submit">
              Reset Password
            </button>
            {error && <p>{error}</p>}
          </form>
        </div>
      </div>
    </div>
  )
}

export default ResetPasswordPage
